<template>
    <v-container>
        <v-layout column class="card" mt-3>
            <v-layout column>
                <v-flex>
                    <v-label><span class="primary--text"></span> Hierarquia</v-label>
                </v-flex>
                <v-flex>
                    <hierarquia
                        v-model="diretores"
                        :id_unidade_negocio="id_unidade_negocio"
                        @editar="setMembroEditando"
                        @excluir="removerMembro"
                        @cancelarEdicao="cancelarEdicao"
                        @updateMembro="({ indices, membro }) => { updateMembro(indices, membro) }"
                        @usuarioSelecionado="usuarioSelecionado" />
                </v-flex>
            </v-layout>
            <v-layout mt-3>
                <v-flex xs2>
                    <v-btn class="btn-default primary" @click="salvar">Salvar</v-btn>
                </v-flex>
                <v-flex xs2>
                    <v-btn class="btn-default primary" @click="exportToExcel">Exportar para Excel</v-btn>
                </v-flex>
            </v-layout>
        </v-layout>
    </v-container>
</template>

<script>
import Rules from '../plugins/validation'
import { alert, error } from '../plugins/helpers'
import { get, orderBy, merge } from 'lodash'
import moment from 'moment'
import Vue from 'vue'

export default {
  name: 'CadastroHierarquia',
  computed: {
    sorted () {
      return this.sort(this.diretores)
    },
    rules: () => Rules,
    id_usuario () {
      return this.$session.get('id_usuario')
    },
    subordinado_hashmap: () => ({
      diretor: 'regional',
      regional: 'gerente',
      gerente: 'supervisor',
      supervisor: 'vendedor',
      vendedor: null
    }),
    TIPO_ALTERACAO_INSERT: () => 'insert',
    TIPO_ALTERACAO_UPDATE: () => 'update',
    TIPO_ALTERACAO_DELETE: () => 'delete'
  },
  data: () => ({
    id_hierarquia: 0,
    id_unidade_negocio: 0,
    unidade_negocio: [],
    diretores: [],
    errors: [],
    editar: false,
    alteracoes: {
      diretor: [],
      regional: [],
      gerente: [],
      supervisor: [],
      vendedor: []
    }
  }),
  watch: {},
  methods: {
    indexOf (item) {
      return this.diretores.indexOf(item)
    },
    sort (diretores) {
      return orderBy(diretores, ['nome'], ['asc'])
    },
    template: () => ({

    }),
    async salvar () {
      if (this.isValido()) {
        // Agrupo as alterações por identificador do superior
        const alteracoes = {
          diretor: this.alteracoes.diretor,
          regional: this.agrupaPorIdUsuarioSuperior('regional'),
          gerente: this.agrupaPorIdUsuarioSuperior('gerente'),
          supervisor: this.agrupaPorIdUsuarioSuperior('supervisor'),
          vendedor: this.agrupaPorIdUsuarioSuperior('vendedor'),
          id_unidade_negocio: this.id_unidade_negocio
        }
        try {
          const { data } = await this.$http.post(`/admin/hierarquias`, alteracoes)

          alert('Hierarquia salva com sucesso')
          this.loadHierarquia()
          this.alteracoes = {
            diretor: [],
            regional: [],
            gerente: [],
            supervisor: [],
            vendedor: []
          }
          return data
        } catch (e) {
          error(e, 'Não foi possível salvar a hierarquia')
        }
      } else {
        alert('Termine a edição antes de salvar')
      }
    },
    exportToExcel () {
      alert({
        text: `Deseja salvar as alterações e exportar a hierarquia para Excel?`,
        buttons: {
          'Cancelar': () => true,
          'Confirmar': () => {
            this.salvar().then(() => {
              this.editar = true

              let params = {}
              params.id_unidade_negocio = this.id_unidade_negocio

              this.$http.get(`/admin/hierarquias/export/${this.id_unidade_negocio}`, {
                responseType: 'blob',
                params
              }).then((r) => {
                const url = window.URL.createObjectURL(new Blob([r.data]))
                const link = document.createElement('a')
                link.href = url
                let data = moment(new Date(), 'DD/MM/YYYY HH:mm').format('DD/MM/YYYY HH:mm')
                link.setAttribute('download', 'Hierarquia-' + this.$session.get('nome_unidade') + '-' + data + '.xlsx')
                document.body.appendChild(link)
                link.click()
              }).catch(err => {
                error(err, 'Não foi possível recuperar as informações.')
              })
            }).catch(err => {
              error(err, 'Não foi possível salvar as informações.').then(() => {
                const payload = get(err, 'response.data.payload')
                if (payload) {
                  this.errors = payload
                }
              })
            })
          }
        }
      })
    },
    isValido () {
      const diretores = this.diretores
      const diretores_editando = diretores.map(membro => membro.editando)

      const regionais = diretores.flatMap(d => d.regionais)
      const regionais_editando = regionais.map(membro => membro.editando)

      const gerentes = regionais.flatMap(r => r.gerentes)
      const gerentes_editando = gerentes.map(membro => membro.editando)

      const supervisores = gerentes.flatMap(g => g.supervisor)
      const supervisores_editando = supervisores.map(membro => membro.editando)

      const vendedores = supervisores.flatMap(s => s.vendedores)
      const vendedores_editando = vendedores.map(membro => membro.editando)
      return [
        ...diretores_editando,
        ...regionais_editando,
        ...gerentes_editando,
        ...supervisores_editando,
        ...vendedores_editando
      ].filter(editando => editando).length === 0
    },
    agrupaPorIdUsuarioSuperior (nivel) {
      const data = {}
      this.alteracoes[nivel].forEach(alteracao => {
        if (!data[alteracao.id_usuario_superior]) {
          data[alteracao.id_usuario_superior] = []
        }
        data[alteracao.id_usuario_superior].push(alteracao)
      })
      return data
    },
    loadHierarquia () {
      this.$http.get(`/admin/hierarquias/${this.id_unidade_negocio}`).then((r) => {
        this.diretores = r.data
        this.editar = true
      }).catch(this.fail)
    },
    loadUnidadeNegocio () {
      this.id_unidade_negocio = this.unidade_negocio = this.$session.get('id_unidade_negocio')
    },
    fail (err) {
      error(err, 'Não foi possível recuperar as informações.')
    },
    setMembroEditando (membro_clicado) {
      this.updateMembro(membro_clicado, { editando: true })
    },
    removerMembro ({ indices, id_hierarquia, nivel, id_usuario }) {
      if (id_hierarquia !== null) {
        // Se tem id_hierarquia é porque o usuário está excluindo um membro que estava salvo no banco de dados
        // Nesse caso, deve-se adicionar uma instrução de 'delete' nas alterações para apagar esse registro no banco
        this.alteracoes[nivel].push({
          tipo: this.TIPO_ALTERACAO_DELETE,
          id_hierarquia
        })
      } else if (id_usuario !== 0) {
        // Se não tem id_hierarquia mas tem id_usuario é porque o usuário ta excluindo um membro que ele acabou de
        // adicionar e ainda não clicou em salvar
        // Nesse caso deve-se (1) remover a instrução de inserção pois o usuário desistiu de inserir esse usuário
        // e (2) remover a inserção que qualquer possível subordinado
        this.removerInstrucaoAlteracao(nivel, id_usuario)
      }

      // Se não tem regional, então o membro clicado foi um diretor
      if (indices.regional_index === undefined) {
        this.diretores.splice(indices.diretor_index, 1)
        return
      }

      const diretor = this.diretores[indices.diretor_index]
      // Se não tem gerente, então o membro clicado foi um regional
      if (indices.gerente_index === undefined) {
        diretor.regionais.splice(indices.regional_index, 1)
        return
      }

      const regional = diretor.regionais[indices.regional_index]
      // Se não tem supervisor, então o membro clicado foi um gerente
      if (indices.supervisor_index === undefined) {
        regional.gerentes.splice(indices.gerente_index, 1)
        return
      }

      const gerente = regional.gerentes[indices.gerente_index]
      // Se não tem vendedor, então o membro clicado foi um supervisor
      if (indices.vendedor_index === undefined) {
        gerente.supervisor.splice(indices.supervisor_index, 1)
        return
      }

      // Senão, foi um vendedor
      const supervisor = gerente.supervisor[indices.supervisor_index]
      supervisor.vendedores.splice(indices.vendedor_index, 1)
    },
    removerInstrucaoAlteracao (nivel, id_usuario) {
      // (1) Removendo a instrução de inserção
      const index = this.alteracoes[nivel].findIndex(membro => membro.id_usuario === id_usuario)
      this.alteracoes[nivel].splice(index, 1)

      // (2) Removendos todas possíveis instruções de inserção dos superdinados
      const nivel_subordinado = this.subordinado_hashmap[nivel]
      if (nivel_subordinado) {
        let index_subordinado = this.alteracoes[nivel_subordinado].findIndex(membro => membro.id_usuario_superior === id_usuario)
        while (index_subordinado !== -1) {
          const subordinado = this.alteracoes[nivel_subordinado][index_subordinado]
          // Chamo a própria função recursivamente pq o subordinado pode ter seus próprios subordinados
          this.removerInstrucaoAlteracao(nivel_subordinado, subordinado.id_usuario)
          index_subordinado = this.alteracoes[nivel_subordinado].findIndex(membro => membro.id_usuario_superior === id_usuario)
        }
      }
    },
    cancelarEdicao (membro_clicado) {
      this.updateMembro(membro_clicado, { editando: false })
    },
    usuarioSelecionado ({ usuario, id_hierarquia, nivel, id_usuario_superior, id_usuario_antigo, superior_fantasma, id_usuario_superior_fantasma, membro }) {
      // Se o id_hierarquia está null é possível que o usuário esteja editando um membro que ele recém adicionou
      // Nesse caso, deve-se (1) remover a antiga instrução de inserir, e (2) ajustar os id_usuarios de todos subordinados
      if (id_hierarquia === null) {
        // (1) Removendo a antiga instrução de inserir
        const index = this.alteracoes[nivel].findIndex(membro => membro.id_usuario === id_usuario_antigo)
        if (index > -1) {
          this.alteracoes[nivel].splice(index, 1)
        }

        // (2) Ajustando qualquer possível subordinado abaixo dele para o novo id_usuario
        const nivel_subordinado = this.subordinado_hashmap[nivel]
        if (nivel_subordinado) {
          this.alteracoes[nivel_subordinado].forEach(subordinado => {
            if (subordinado.id_usuario_superior === id_usuario_antigo) {
              subordinado.id_usuario_superior = usuario.id_usuario
            }
          })
        }
      }

      this.alteracoes[nivel].push({
        tipo: id_hierarquia === null ? this.TIPO_ALTERACAO_INSERT : this.TIPO_ALTERACAO_UPDATE,
        id_hierarquia,
        id_usuario: usuario.id_usuario,
        id_usuario_fantasma: usuario.id_usuario_fantasma,
        id_usuario_superior,
        superior_fantasma,
        id_usuario_superior_fantasma
      })

      this.updateMembro(membro, {
        editando: false,
        hierarquia: {
          // Essa prop é usada pra enviar no 'not' do autocomplete, para evitar de colocar um cara q já está na hieraquia
          id_usuario: usuario.id_usuario,
          usuario
        }
      })
    },
    /** Recebe um objeto contendo a posição no array do membro clicado e todas as posições dos membros superiores à ele,
       * usa essas informações para encontrar o membro dentro do array $data.diretores e da um merge com o objeto do
       * segundo parâmetro
       * @param indices.diretor_index - Obrigatório
       * @param indices.regional_index - Opcional
       * @param indices.gerente_index - Opcional
       * @param indices.supervisor_index - Opcional
       * @param indices.vendedor_index - Opcional
       */
    updateMembro (indices, membro) {
      if (indices.diretor_index === undefined) {
        this.diretores = membro.diretores
        return
      }

      // Se não tem regional, então o membro clicado foi um diretor
      if (indices.regional_index === undefined) {
        Vue.set(this.diretores, indices.diretor_index, merge({ ...this.diretores[indices.diretor_index] }, membro))
        return
      }

      const diretor = this.diretores[indices.diretor_index]
      // Se não tem gerente, então o membro clicado foi um regional
      if (indices.gerente_index === undefined) {
        Vue.set(diretor.regionais, indices.regional_index, merge({ ...diretor.regionais[indices.regional_index] }, membro))
        return
      }

      const regional = diretor.regionais[indices.regional_index]
      // Se não tem supervisor, então o membro clicado foi um gerente
      if (indices.supervisor_index === undefined) {
        Vue.set(regional.gerentes, indices.gerente_index, merge({ ...regional.gerentes[indices.gerente_index] }, membro))
        return
      }

      const gerente = regional.gerentes[indices.gerente_index]
      // Se não tem vendedor, então o membro clicado foi um supervisor
      if (indices.vendedor_index === undefined) {
        Vue.set(gerente.supervisor, indices.supervisor_index, merge({ ...gerente.supervisor[indices.supervisor_index] }, membro))
        return
      }

      // Senão, foi um vendedor
      const supervisor = gerente.supervisor[indices.supervisor_index]
      Vue.set(supervisor.vendedores, indices.vendedor_index, merge({ ...supervisor.vendedores[indices.vendedor_index] }, membro))
    }
  },
  mounted () {
    this.loadUnidadeNegocio()
    this.loadHierarquia()
  }
}
</script>

<style scoped>

</style>
